/**
 * Voucher Page Module
 * Obsługuje rozwijanie/zwijanie sekcji instrukcji (read more)
 * oraz usuwanie cienia ze sticky CTA bar gdy jest odpięty.
 */

(function () {
    'use strict';

    // ----------------------------------------
    // Instruction Read More
    // ----------------------------------------
    var content = document.querySelector('.voucher__instruction-content');
    var btn = document.querySelector('.voucher__read-more');

    if (content && btn) {
        var COLLAPSED_HEIGHT = 154; // 7 lines × 22px
        var expanded = false;

        // Show button only if content overflows
        if (content.scrollHeight > COLLAPSED_HEIGHT) {
            btn.classList.add('is-visible');
        }

        btn.addEventListener('click', function () {
            if (!expanded) {
                content.style.maxHeight = content.scrollHeight + 'px';
                btn.textContent = 'Czytaj mniej';
                expanded = true;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                content.offsetHeight; // force reflow
                content.style.maxHeight = COLLAPSED_HEIGHT + 'px';
                btn.textContent = 'Czytaj więcej';
                expanded = false;
            }
        });

        // After expand transition ends, allow responsive layout
        content.addEventListener('transitionend', function () {
            if (expanded) {
                content.style.maxHeight = 'none';
            }
        });
    }

    // ----------------------------------------
    // Sticky CTA — shadow removal on unpin
    // ----------------------------------------
    var ctaBar = document.getElementById('voucherMobileCta');
    var sentinel = document.getElementById('voucherCtaSentinel');

    if (ctaBar && sentinel) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                ctaBar.classList.toggle('is-unpinned', entry.isIntersecting);
            });
        }, { threshold: 0 });

        observer.observe(sentinel);
    }

    // ----------------------------------------
    // Sticky Code Bar — shadow removal on unpin
    // ----------------------------------------
    var codeBar = document.getElementById('voucherMobileCode');
    var codeSentinel = document.getElementById('voucherCodeSentinel');

    if (codeBar && codeSentinel) {
        var codeObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                codeBar.classList.toggle('is-unpinned', entry.isIntersecting);
            });
        }, { threshold: 0 });

        codeObserver.observe(codeSentinel);
    }

    // ----------------------------------------
    // Sticky Download Bar — shadow removal on unpin
    // ----------------------------------------
    var downloadBar = document.getElementById('voucherMobileDownload');
    var downloadSentinel = document.getElementById('voucherDownloadSentinel');

    if (downloadBar && downloadSentinel) {
        var downloadObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                downloadBar.classList.toggle('is-unpinned', entry.isIntersecting);
            });
        }, { threshold: 0 });

        downloadObserver.observe(downloadSentinel);
    }
})();

/**
 * Voucher Code Copy
 * Kopiuje kod vouchera do schowka po kliknięciu przycisku "Skopiuj kod".
 * Obsługuje zarówno przycisk desktop jak i mobile.
 */

(function () {
    'use strict';

    var copyButtons = document.querySelectorAll('.voucher__copy-btn');
    var codeEl = document.getElementById('voucherCode') || document.getElementById('voucherCodeMobile');

    if (!copyButtons.length || !codeEl) return;

    function handleCopy(btn) {
        var code = codeEl.textContent.trim();

        function showSuccess() {
            // Update all copy buttons
            copyButtons.forEach(function (b) {
                b.textContent = 'Skopiowano!';
                b.classList.add('is-copied');
            });
            setTimeout(function () {
                copyButtons.forEach(function (b) {
                    b.textContent = 'Skopiuj kod';
                    b.classList.remove('is-copied');
                });
            }, 2000);
        }

        navigator.clipboard.writeText(code).then(showSuccess).catch(function () {
            // Fallback for older browsers
            var textarea = document.createElement('textarea');
            textarea.value = code;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            showSuccess();
        });
    }

    copyButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            handleCopy(btn);
        });
    });
})();
